import { render, staticRenderFns } from "./DatePropertiesToInclude.vue?vue&type=template&id=7960c7ec&scoped=true"
import script from "./DatePropertiesToInclude.vue?vue&type=script&lang=js"
export * from "./DatePropertiesToInclude.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7960c7ec",
  null
  
)

export default component.exports